export default "__VITE_ASSET__25c1a061__"